module.exports = __webpack_public_path__ + "img/daily_necessities_etc.374bf07c.jpg";